import { useState } from "react";
import FindAccount from "../../components/controls/FindAccount/FindAccount";
import GridView from "../../components/controls/GridView/GridView";
import cls from "./balance-enquiry.module.css";
import { AccountDto } from "../../services/accountService";
import Frame from "../../components/controls/Frame/Frame";

export interface BalanceEnquiryProps {}

export const BalanceEnquiry = (props: BalanceEnquiryProps) => {
  const [account, setAccount] = useState<AccountDto>();

  return (
    <>
      <div className="row">
        <div className="col">
          <Frame>
            <fieldset>
              <div className="row">
                <div className="col-9">
                  <FindAccount
                    id="account"
                    text="Select Account"
                    onAccountSelected={(account) => {
                      // get the account balance of the account and sets the state
                      setAccount(account);
                    }}
                  />

                  {account && <hr />}

                  {account && (
                    <div className="row">
                      <div className="col">
                        <p>
                          <b>AccountType</b> : {account?.accountTypeName}
                        </p>
                      </div>
                      <div className="col">
                        <p>
                          <b>Account Group</b>: {account?.accountGroupName}
                        </p>
                      </div>
                    </div>
                  )}

                  {account && (
                    <div className="row">
                      <div className="col">
                        <p>
                          <b>Account Balance:</b>
                        </p>
                      </div>
                      <div className="col">
                        <p>
                          <b>Gross Balance:</b>
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-3 d-flex justify-content-center">
                  <img
                    src="https://placeholder.com/300x300"
                    alt="Signature"
                    className={cls.signature}
                  />
                </div>
              </div>
            </fieldset>
          </Frame>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Frame>
            <fieldset>
              <legend>Loans</legend>
              <div>
                <GridView<{
                  loanId: number;
                  loanAccountName: string;
                  loanAccountNo?: string;
                  amount: number;
                  balance: number;
                }> name="lstLoans" />
              </div>
            </fieldset>
          </Frame>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Frame>
            <fieldset>
              <legend>Overdrafts</legend>
              <div>
                <GridView rowsPerPage={50} name="lstOverdrafts" />
              </div>
            </fieldset>
          </Frame>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Frame>
            <fieldset>
              <legend>Lien</legend>
              <div>
                <GridView rowsPerPage={50} name="lstAccountLien" />
              </div>
            </fieldset>
          </Frame>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <Frame>
            <fieldset>
              <legend>Hold Fund(s)</legend>
              <div>
                <GridView<{
                  id: number;
                  reason: string;
                  dateEntered: string;
                  amount: number;
                }>
                  rowsPerPage={50}
                  name="lstAccountLien"
                />
              </div>
            </fieldset>
          </Frame>
        </div>
      </div>
    </>
  );
};
